import { render, staticRenderFns } from "./MetricWidget.vue?vue&type=template&id=4e766af8&scoped=true&"
import script from "./MetricWidget.vue?vue&type=script&lang=js&"
export * from "./MetricWidget.vue?vue&type=script&lang=js&"
import style0 from "./MetricWidget.vue?vue&type=style&index=0&id=4e766af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e766af8",
  null
  
)

export default component.exports